import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/App';
import { AuthProvider } from '@/auth/auth-context';
import './styles.css';

// Single QueryClient instance for the lifetime of the app. Defaults are fine
// for an admin tool: refetchOnWindowFocus stays on (founder switches tabs
// constantly while reviewing PDFs), retry once on failure (the backend is
// our own — a 5xx is usually informative on the first try and there's no
// point hammering it).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
